import { api } from 'src/api/axios';

export const useDeleteTemplate = (id: number | string) => api.delete(`/api/cms/template-design/${id}`);
